import * as types from "./mutation-types";
import Services from "@/services";

export const loading = ({ commit }) => {
  commit(types.LOADING);
};

export const loaded = ({ commit }) => {
  commit(types.LOADED);
};

export const login = ({ commit }) => {
  commit(types.LOGIN);
};

export const logout = ({ commit }) => {
  commit(types.LOGOUT);
};

export const downloadLayout = ({ commit }, companyName) => {
  Services.getById("Configuration/GetLayout", companyName)
    .then(response => {
      commit(types.SETLAYOUT, response.data);
      commit(types.SETCONTRASTLAYOUT);
    })
    .catch(error => {
      console.log("Error while downloading layout", error);
    });
};

export const setKey = ({ commit }) => {
  commit(types.SETKEY);
};

export const setBaseFontSize = ({ commit }, size) => {
  commit(types.SETBASEFONTSIZE, size);
};

export const setContrast = ({ commit }, contrast) => {
  commit(types.SETCONTRASTLAYOUT, contrast);
};

export const setCompanyName = ({ commit }, companyName) => {
  commit(types.SET_COMPANY_NAME, companyName);
};
export const setLocales = ({ commit }, locales) => {
  commit(types.SET_LOCALES, locales);
};

export const pushLocales = ({ commit }, { company, locale }) => {
  commit(types.PUSH_LOCALES, { company, locale });
};
